

  export default {
    safeRule: function(value, num1, num2, isShow){
        if (value) {
            if(isShow){
                // console.log('11,' , value)
                return value
            }else {
                return value.substr(0, num1) + '****' + value.substr(value.length - num2, value.length);
            }

          } else {
            return '--';
          }
    }
  }


// WEBPACK FOOTER //
// ./src/assets/js/safeRule.js